export default __webpack_public_path__ + "static/media/info-grey.a9317eb7.svg";